import React, { Component } from 'react';
import { connect } from 'react-redux';
import AmazonCrossCheckView from './AmazonCrossCheck.view';

export class AmazonCrossCheckContainer extends Component {

  constructor(props) {
    super(props);
    this.onFormUpdate = this.onFormUpdate.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  closeModal() {
    const { dispatch } = this.props;
    dispatch({
      type: 'TOGGLE_CROSS_CHECK_MODAL',
      payload: {
        active: false,
      }
    });
  }

  addRow() {
    const { dispatch } = this.props;
    dispatch({
      type: 'CREATE_FORM_ADD_PAYMENT',
      payload: {},
    });
  }

  removeRow(index) {
    const { dispatch } = this.props;
    dispatch({
      type: 'CREATE_FORM_REMOVE_PAYMENT',
      payload: {
        index,
      },
    });
  }

  onFormUpdate(formState, actions) {
    const { dispatch } = this.props;
    dispatch({
      type: 'ON_CROSS_CHECK_FORM_UPDATE',
      payload: {
        formState,
      },
    });
  }

  submitForm(formState) {
    const { dispatch } = this.props;
    dispatch({
      type: 'FETCH_CROSS_CHECK_PAYMENTS',
      payload: {
        data: formState.data,
      },
    });
  }

  render() {
    return (<AmazonCrossCheckView
      {...this.state}
      {...this.props}
      closeModal={this.closeModal}
      onFormUpdate={this.onFormUpdate}
      submitForm={this.submitForm}
      addRow={this.addRow}
      removeRow={this.removeRow}
    />);
  }

}

function mapStateToProps(state) {
  const { payments, dynamicData } = state;
  return {
    crossCheckModalActive: payments.crossCheckModalActive,
    formState: payments.crossCheckFormState,
    crossCheckPayments: payments.crossCheckPayments,
    missingCodes: payments.missingCodes,
    amazonAccounts: dynamicData.amazonAccounts,
  };
}

export default connect(mapStateToProps)(AmazonCrossCheckContainer);



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Payments/AmazonCrossCheck/AmazonCrossCheck.container.js